/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import {StyleSheet, View} from 'react-native';
import { ScreenWidth } from 'react-native-elements/dist/helpers';

export type GridVProps = {
  align?: 'top' | 'middle' | 'bottom';
  justify?:
    | 'start'
    | 'end'
    | 'center'
    | 'space-around'
    | 'space-between'
    | 'space-evenly';
  children: any;
  width?: any;
};

export type GridItemVProps = {
  children?: any;
  colSpan?: string;
};

const styles = StyleSheet.create({
  gridItem: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    flex: 0,
    width: ScreenWidth*1,
  },
});

const getAlign = (align?: 'top' | 'middle' | 'bottom') => {
  const _align = {
    alignItems: 'center',
  };
  if (align) {
    if (align === 'top') {
      _align.alignItems = 'flex-start';
    }
    if (align === 'bottom') {
      _align.alignItems = 'flex-end';
    }
  }
  return {..._align};
};

const getJustify = (
  justify?:
    | 'start'
    | 'end'
    | 'center'
    | 'space-around'
    | 'space-between'
    | 'space-evenly',
) => {
  const _justify = {
    justifyContent: 'flex-start',
  };
  if (justify) {
    if (justify === 'end') {
      _justify.justifyContent = 'flex-end';
    } else if (justify === 'start') {
      _justify.justifyContent = 'flex-start';
    } else {
      _justify.justifyContent = justify;
    }
  }

  return {..._justify};
};

export const GridV = (props: GridVProps) => {
  return (
    <View
      style={StyleSheet.flatten([
        styles.gridItem,
        props.width && {width: props.width},
        getJustify(props.justify),
        getAlign(props.align),
      ])}
    >
      {props.children}
    </View>
  );
};

export const GridItemV = (props: GridItemVProps) => {
  return (
    <View
      style={StyleSheet.flatten([
        {},
        props.colSpan && {width: props.colSpan},
      ])}
    >
      {props.children}
    </View>
  );
};
